import { forwardRef } from 'react';
import styled, { th } from '@xstyled/styled-components';
import { HideInput } from '../utils';

const RadioButtonContainer = styled.label`
  display: inline-flex;
  align-items: center;
`;

const HiddenRadioButton = styled.input.attrs({ type: 'radio' })`
  ${HideInput}
`;

const StyledRadioButton = styled.div`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.75rem;
  width: 20px;
  height: 20px;
  border: 1px solid ${th.color('purple-200')};
  border-radius: 50%;
  background-color: ${({ checked }) =>
    checked ? th.color('purple-200') : 'white'};
  outline: ${({ checked }) => checked && 'none'};
  cursor: ${({ disabled }) => !disabled && 'pointer'};

  &:after {
    position: absolute;
    content: '';
    width: 6px;
    height: 6px;
    background-color: white;
    border-radius: 50%;
  }
`;

const RadioButton = forwardRef((props, ref) => {
  const checked = props.checked === props.value;
  return (
    <RadioButtonContainer>
      <HiddenRadioButton
        ref={ref}
        name={props.name}
        value={props.value}
        checked={checked}
        onChange={props.onChange}
        disabled={props.disabled}
      />
      <StyledRadioButton checked={checked} disabled={props.disabled} />
      {props.label}
    </RadioButtonContainer>
  );
});

RadioButton.displayName = 'RadioButton';

export default RadioButton;
